var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03386 1.50684C4.03386 0.942383 4.4987 0.444336 5.09636 0.444336C5.66081 0.444336 6.15886 0.942383 6.15886 1.50684V2.56934H10.4089V1.50684C10.4089 0.942383 10.8737 0.444336 11.4714 0.444336C12.0358 0.444336 12.5339 0.942383 12.5339 1.50684V2.56934H14.1276C14.9909 2.56934 15.7214 3.2998 15.7214 4.16309V5.75684H0.846359V4.16309C0.846359 3.2998 1.54362 2.56934 2.44011 2.56934H4.03386V1.50684ZM15.7214 15.8506C15.7214 16.7471 14.9909 17.4443 14.1276 17.4443H2.44011C1.54362 17.4443 0.846359 16.7471 0.846359 15.8506V6.81934H15.7214V15.8506Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSolid);
export default __webpack_public_path__ + "static/media/calendar-solid.5cad75aff7fbbff67ea0df8993a05c20.svg";
export { ForwardRef as ReactComponent };